import styled from 'styled-components';

export const CardContainer = styled.div`
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 8px;
  border: 2px solid #d1d1d1;
  height: auto;
  border-radius: 4px;
  position: relative;
  z-index: 100;
  padding: 8px;
  border: 2px solid ${(props) => props.iconBG.bg};
  .iconn {
    position: absolute;
    left: -18px;
    top: 40px;
    background-color: ${(props) => props.iconBG.bg};
    border-radius: 50%;
    z-index: 99;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .iconGWhite {
    position: absolute;
    left: -22px;
    top: 36px;
    width: 38px;
    height: 38px;
    z-index: 1;
    background-color: #ffffff;
    border-radius: 50%;
    border: 2px solid #d1d1d1;
  }
`;

export const InformacoesParcela = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const Top = styled.div`
  display: flex;

  justify-content: space-between;

  &:nth-child(2) {
    margin-top: 8px;
  }

  .item {
    display: flex;
    gap: 4px;
    align-items: center;

    &:first-child {
      width: ${(props) => props.size};
      padding-left: 0px;
    }

    span {
      font-size: 12px;
      color: #4d4d4d;
      &:last-child {
        font-size: 14px;
        color: ${(props) => props.iconBG.color};
        font-weight: bold;
      }
    }
  }
`;
